import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

declare var google: any;

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {
  private geocoder: any;
  private distanceService: any;

  constructor(private zone: NgZone) {
    this.initServices();
  }

  private initServices() {
    if (typeof google !== 'undefined' && google.maps) {
      this.geocoder = new google.maps.Geocoder();
      this.distanceService = new google.maps.DistanceMatrixService();
    }
  }

  getDistance(origin: string, destination: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.distanceService) {
        this.initServices();
        if (!this.distanceService) {
          reject(new Error('No se pudo cargar el servicio de Google Maps'));
          return;
        }
      }

      try {
        const [originLat, originLng] = origin.split(',').map(Number);
        const [destLat, destLng] = destination.split(',').map(Number);

        if (
          isNaN(originLat) ||
          isNaN(originLng) ||
          isNaN(destLat) ||
          isNaN(destLng)
        ) {
          throw new Error('Coordenadas inválidas');
        }

        this.distanceService.getDistanceMatrix(
          {
            origins: [{ lat: originLat, lng: originLng }],
            destinations: [{ lat: destLat, lng: destLng }],
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.METRIC,
          },
          (response: any, status: string) => {
            this.zone.run(() => {
              if (status === 'OK') {
                if (!response.rows?.[0]?.elements?.[0]) {
                  reject(
                    new Error(
                      'No se pudo calcular la distancia entre las ubicaciones'
                    )
                  );
                  return;
                }
                resolve(response);
              } else {
                reject(new Error('Error al calcular la distancia'));
              }
            });
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  geocodeAddress(address: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.geocoder) {
        this.initServices();
        if (!this.geocoder) {
          reject(new Error('No se pudo cargar el servicio de geocodificación'));
          return;
        }
      }

      this.geocoder.geocode({ address }, (results: any[], status: string) => {
        this.zone.run(() => {
          if (status === 'OK') {
            if (!results?.[0]?.geometry?.location) {
              reject(new Error('No se pudo encontrar la dirección'));
              return;
            }
            const result = {
              results: [
                {
                  geometry: {
                    location: {
                      lat: results[0].geometry.location.lat(),
                      lng: results[0].geometry.location.lng(),
                    },
                  },
                },
              ],
            };
            resolve(result);
          } else {
            reject(new Error('Error al geocodificar la dirección'));
          }
        });
      });
    });
  }
}
